import * as React from "react";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useLanguage } from "../../Language";
import { Gender } from "../../AccountSummaryAlerts";

export interface GenderFieldProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  required?: boolean;
}

export const GenderField = <T extends FieldValues>({
  name,
  label,
  required,
}: GenderFieldProps<T>) => {
  const { formState, getFieldState, control } = useFormContext<T>();
  const { error } = getFieldState(name, formState);
  const { translate } = useLanguage();
  return (
    <Controller<T>
      name={name}
      control={control}
      rules={{
        validate: {
          required: (value) =>
            !required ||
            value !== Gender.Unspecified ||
            `${translate("isRequired", {
              LABEL: label,
            })}`,
        },
      }}
      render={({ field: { value, ref, ...field } }) => {
        return (
          <FormControl
            sx={{ maxWidth: { sm: "320px" } }}
            error={!!error}
            required={!!required}
          >
            <InputLabel id={`${field.name}-label`}>{label}</InputLabel>
            <Select
              labelId={`${field.name}-label`}
              id={field.name}
              value={value === Gender.Unspecified ? "" : value}
              {...field}
              inputProps={{ ref: ref }}
              label={label}
            >
              <MenuItem value={Gender.Female}>
                {translate("ci_gender_female")}
              </MenuItem>
              <MenuItem value={Gender.Male}>
                {translate("ci_gender_male")}
              </MenuItem>
            </Select>
            <FormHelperText>{error?.message || " "}</FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};
